<section>
  <app-content-container>
    <div class="flex flex-col items-center">
      <div class="max-w-[780px] w-full">
        <h1 class="section-title font-bold text-center">Nossos super cursos</h1>

        <p
          class="w-full max-w-[750px] section-description leading-relaxed text-center mt-8"
        >
          Nossa meta é tornar você uma pessoa desenvolvedora
          <strong class="angular-font-color">Angular</strong>
          de altíssimo nível através de cursos que são realmente relevantes!
        </p>
      </div>
      <div class="mt-28 flex justify-center flex-wrap gap-8">
        @for (item of courses(); track item.title) {
        <div class="action-card" [attr.data-testid]="item.title">
          <div
            class="relative flex items-center justify-center overflow-hidden h-40 shrink-0 border-b border-white/10 bg-linear-to-br"
            [class]="item.gradientClass"
          >
            <!-- Background Grid Pattern & Radial Glow -->
            <div
              class="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none"
            ></div>
            <div
              class="absolute w-36 h-36 rounded-full blur-3xl opacity-60 group-hover:opacity-90 transition-opacity duration-500 pointer-events-none"
              [style.background]="item.glowColor ?? 'rgba(102,87,236,0.3)'"
            ></div>

            <!-- Technology SVG Logo with Frosted Glass & Diffused Glow -->
            @if (item.iconUrl) {
            <div
              class="relative z-10 flex items-center justify-center w-14 h-14 rounded-2xl bg-white/6 border border-white/10 backdrop-blur-md shadow-lg shadow-black/20 group-hover:bg-white/12 group-hover:border-white/20 group-hover:scale-110 transition-all duration-300"
            >
              <img
                class="w-7 h-7 object-contain opacity-80 group-hover:opacity-100 drop-shadow-[0_0_10px_rgba(255,255,255,0.35)] transition-opacity duration-300"
                [src]="item.iconUrl"
                [alt]="item.iconAlt ?? item.title"
                loading="lazy"
              />
            </div>
            } @else if (item.imageUrl) {
            <img
              class="h-full max-h-40 object-cover"
              [src]="item.imageUrl"
              [alt]="item.imageAlt ?? item.title"
            />
            }
          </div>
          <div class="card-body p-6 flex flex-col flex-1">
            <div class="flex flex-wrap gap-2">
              <app-complexity-level [level]="item.level"></app-complexity-level>

              @if (item.badgeText && item.badgeClass) {
              <div class="badge" [class]="item.badgeClass">
                {{ item.badgeText }}
              </div>
              }
            </div>

            <h2 class="card-title mt-2 text-xl font-bold text-white">
              {{ item.title }}
            </h2>

            <p class="mt-3 text-gray-300 text-sm leading-relaxed">
              {{ item.description }}
            </p>

            <div class="card-actions mt-auto pt-4">
              @if (item.url.startsWith('http')) {
              <a
                class="btn btn-primary w-full shadow-lg"
                [attr.data-testid]="'courses-section-' + item.title | replaceWhitespaceWithHyphen"
                [href]="item.url"
              >
                Acessar curso
              </a>
              } @else {
              <a
                class="btn btn-primary w-full shadow-lg"
                [attr.data-testid]="'courses-section-' + item.title | replaceWhitespaceWithHyphen"
                [routerLink]="item.url"
              >
                Acessar curso
              </a>
              }
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </app-content-container>
</section>
